export default __webpack_public_path__ + "static/media/logout.97185d98.svg";